(function() {
  'use strict';

  angular.module('cfn').directive('dTab', function() {
    return {
      transclude: true,
      restrict: 'E',
      require: '^dTabContainer',
      scope: {
        index: '@',
        clickAction: '&?',
        cls: '@'
      },
      templateUrl: require('./d-tab.html'),
      link: function(scope, el, attrs, ctrl) {
        scope.tabsCtrl = ctrl;
        scope.setActiveIndex = function() {
          ctrl.setActiveIndex(scope.index);
          if (scope.clickAction) {
            scope.clickAction();
          }
        };
      }
    };
  });
})();
